import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react/dist/iconify.js";
import QuotationDetailsSkeleton from "./Skeleton";
import "./style.css";
import "./SkeletonStyle.css";
import QuotationInfo from "./Components/QuotationInfo";
import PaymentInfo from "./Components/PaymentInfo";
import { LS } from "@/utils/localStorage";
import { useGet } from "@/api/hooks";
import { GetProviderQuotationResponseDetails } from "@/api/endpoints/Broker/BrokerRequest";
import { Block, CRButton, CRRender } from "@/components/crRender";
import NoData from "@/components/NoData";
import QuotationInvoice from "./Components/QuotationInvoice";


interface AddOn {
    id: number;
    name: string;
    description: string;
    price: number;
    isSelected?: boolean;
}

interface QuotationDetails {
    providerName: string;
    serviceName: string;
    price: number;
    orderId: number;
    availableFromDate: string;
    postServices: Record<string, string | number>[]
    availableToDate: string;
    patientSelectedDate: string;
    pendingPaymentAmount: number;
    paidPrice: number;
    services: string[];
    addOns: AddOn[];
    refundPolicy: string;
    paymentTerms: string;
    paymentPercentage: number;
    orderStatusId: number;
}

const QuotationDetailsPage = () => {

    const [selectedAddOns, setSelectedAddOns] = useState<number[]>([]);
    const [selectedPostServices, setSelectedPostServices] = useState<number[]>(LS.getItemString('sPS') || []);
    const [scheduledDate, setScheduledDate] = useState<Date | null>(null);

    const navigate = useNavigate();
    const { t } = useTranslation();

    const { medicalOrderId, hospitlaOrderId } = useParams();

    const { result: quotationData, isPending: loading } = useGet<any>({
        endPoint: GetProviderQuotationResponseDetails,
        params: [hospitlaOrderId,medicalOrderId],
        defaultValue: null,
        allowFetch: true,
        shortPullTime: 10000,
        depArr: [hospitlaOrderId,medicalOrderId],
    })

    const ToggleCheckBox = (setter, id) =>  setter(prev => prev.includes(id) ? prev.filter(e => e != id) : [...prev, id]);

    useEffect(() => {
        LS.setItemString('sPS', selectedPostServices);
    }, [ selectedPostServices])

    const handlePrint = () => {
        window.print();
    }


    if (loading) {
        return <QuotationDetailsSkeleton />;
    }


    return (
        <>
            <Block isRender={!loading && !!quotationData?.orderId} className="quotation-details-page">

                <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="qd-back-link" onClick={() => navigate(-1)}>
                        <Icon icon="mdi:arrow-left" width={16} />
                        <span>{t("Back to Request Details")}</span>
                    </div>
                    <CRButton 
                        className="qd-print-btn" 
                        loading={loading} title={`${t("Print")}`}
                        onClick={handlePrint}
                        icon="mdi:printer" />
                </div>

                <h1 className="qd-title"> {t("Quotation Response")} </h1>

                <p className="qd-subtitle"> {t("From")} {quotationData?.providerName} </p>

                <div className="qd-layout">

                    <QuotationInfo quotationData={quotationData} setScheduledDate={setScheduledDate} selectedAddOns={selectedAddOns} selectedPostServices={selectedPostServices} scheduledDate={scheduledDate} ToggleCheckBox={ToggleCheckBox} setSelectedAddOns={setSelectedAddOns} setSelectedPostServices={setSelectedPostServices} />

                    <PaymentInfo quotationData={quotationData} selectedAddOns={selectedAddOns} selectedPostServices={selectedPostServices} scheduledDate={scheduledDate} />

                </div>
            </Block >

            <div className="qd-invoice-print-only">
                <QuotationInvoice quotationData={quotationData} selectedAddOns={selectedAddOns} selectedPostServices={selectedPostServices} />
            </div>

            <CRRender isRender={!loading && !quotationData?.orderId}>
                <NoData />
            </CRRender>
        </>

    );
};

export default QuotationDetailsPage;



